module.exports = __webpack_public_path__ + "img/logo-1.469a1842.png";